import React from 'react';
import s from './s.module.less';
import GoogleIcon from './google.png';
import AuthButton from 'pages/dashboard/CalendarManagePage/components/AuthButton';
import { Button, Tag } from 'antd';
import { PATH } from 'constants/path';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';

type Props = {
    onNext: () => void;
    onBack: () => void;
    nextButtonText?: string;
    successCallbackPath?: string;
};

export default function GoogleSync(props: Props) {
    const { onNext, onBack, nextButtonText, successCallbackPath } = props;
    const [authStatus, loadingStatus, fetchStatus] = useGoogleAuthStatus();

    const showAuth = authStatus && authStatus.connectSwitch !== true;
    const showConnect = authStatus && authStatus.connectSwitch === true;
    return (
        <div className={s.googleWrap}>
            <h4>Connect your Google calendar</h4>
            <div className={s.des}>
                Link your Google calendar to avoid double-booking and manage your availability seamlessly.
            </div>
            <div className={s.area}>
                <div className={s.title}>
                    <img src={GoogleIcon} alt="Google" />
                    <div className={s.titleText}>
                        Google calendar integration
                        {showConnect && (
                            <Tag color="#0E62F4" style={{ marginLeft: '6px' }}>
                                Connected
                            </Tag>
                        )}
                    </div>
                </div>
                <div className={s.content}>
                    <ul className={s.des}>
                        <li>Klarity appointments will show up as a separate sub-calendar in your Google calendar. </li>
                        <li>
                            You can’t cancel or modify Klarity appointments directly in your personal calendar; any
                            changes must be made within Klarity Health.
                        </li>
                    </ul>
                    {showAuth && (
                        <div className={s.btnWrap}>
                            <AuthButton
                                block
                                type="primary"
                                text="Connect Google calendar"
                                successCallbackPath={
                                    successCallbackPath ?? `${PATH.PPA_ONBOARDING_ADVANCE_SETTING}?tab=google_sync`
                                }
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="flex gap-4 mb-9 mt-6">
                <Button onClick={onBack} className="bg-white">
                    Back
                </Button>
                <Button type="primary" onClick={onNext}>
                    {nextButtonText ?? 'Next'}
                </Button>
            </div>
        </div>
    );
}
